import React from 'react'
import { Button, Modal } from 'antd'
import { CloseIco, ModalCloseIco } from '../../../modules/CustomIcons'

import './index.scss'

interface ModalProps {
  children: React.ReactNode
  visible: boolean,
  title: String,
  okText?: String,
  width?: number,
  height?: number,
  // setVisible: (visibility: Boolean) => void
  onOk?: () => void,
  className?: string,
  onCancel?: () => void
  footer?: React.ReactNode | null

}
const ModalComponent: React.FC<ModalProps> = ({children,onOk, visible,title,
                                                  onCancel,className,width, height,
                                                  okText, footer}) => {
  return (
    <div className='notificationWarningModal'>
      <Modal
        okText={okText}
        okButtonProps={{style: {background: '#015CD1'}}}
        title={title}
        centered
        open={visible}
        onOk={onOk}
        closeIcon={<ModalCloseIco />}
        onCancel={onCancel}
        okType='primary'
        width={width}
        height = {height}
        className={className}
        cancelButtonProps={{ style: { display: 'none' } }}
        footer={footer}
      >
        {children}
      </Modal>
    </div>
  )
}

export default ModalComponent
